<div class="page-wrapper">
  <div class="content container-fluid">
    <ng-content></ng-content>
  </div>
</div>
